import Field from './Field'

export default function FieldMultiSelect (label, key, items, rules, options, on) {
  Field.call(this, label, key, rules, options, on)
  this.type = 'select'
  this.multiple = true
  this.items = items
}



// WEBPACK FOOTER //
// ./packages/helper/fields/FieldMultiSelect.js